import React from 'react';
import { renderHTMLContent } from '../../common/function';

function CustomCardHeader(props) {
  const {
    headingText,
    headerImage,
    imageWidth = '30',
    navigateButtonClassName,
    showPreviousButton,
    showNextButton,
    getPreviousQuestion,
    getNextQuestion,
    disabledNextButton,
    disabledPreviousButton,
    className,
    headerClassName,
    children,
  } = props;
  return (
    <div className={`card-header ${headerClassName || ''}`}>
      {headerImage && (
        <img src={headerImage} className='margin_right_20' width={imageWidth} alt='header-image' />
      )}
      {renderHTMLContent(headingText, "span", className || "", { contentEditable: 'false' })}
      <div className={`float-right text-right ${navigateButtonClassName || ''}`}>
        {showPreviousButton && (
          <button
            type='button'
            aria-label='Previous question'
            className={`fa fa-angle-left ques_arrow pointer_class ${disabledPreviousButton && 'text-secondary'
              }`}
            onClick={getPreviousQuestion}
            disabled={disabledPreviousButton}
          />
        )}
        {showNextButton && (
          <button
            type='button'
            aria-label='Next question'
            className={`fa fa-angle-right ques_arrow pointer_class ${disabledNextButton && 'text-secondary'
              }`}
            onClick={getNextQuestion}
            disabled={disabledNextButton}
          />
        )}
        {children}
      </div>
    </div>
  );
}

export default CustomCardHeader;



// WEBPACK FOOTER //
// ./src/Components-2025/QuestionBank/CustomCardHeader.jsx